import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-accessory-information',
  templateUrl: './accessory-information.component.html',
  styleUrl: './accessory-information.component.scss',
  standalone: true,
})
export class AccessoryInformationComponent {
  @Input({ required: true }) imageUrl: string;
  @Input() webShopLink: string;
  @Input({ required: true }) name: string;
  @Input({ required: true }) keyInformation: string[];
  @Input({ required: true }) manufacturer: string;
}
